import React, { useContext, useEffect } from 'react';
import Header from 'components/Header';
import Sidebar from 'components/Sidebar';
import { Outlet } from 'react-router-dom';
import { SidebarContext } from 'context/SidebarContext';
import { useNavigate } from 'react-router';

export default function DashboardLayout() {
  const navigate = useNavigate();

  const { isSideMenuOpen, checkLogin } = useContext(SidebarContext);

  useEffect(() => {
    if (!checkLogin()) {
      navigate('/login', { replace: true });
    }
  }, [navigate]);

  return (
    <div
      className={`flex h-screen bg-gray-50 dark:bg-gray-900 ${isSideMenuOpen ? 'overflow-hidden' : ''
        }`}
    >
      <Sidebar />
      <div className="flex flex-col flex-1 w-full">
        <Header />
        <main className="h-full overflow-y-auto">
          <div className="container grid px-6 mx-auto">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}
